import {
  formatDuration, formatDistanceToNow, intervalToDuration, parseISO, differenceInDays, addSeconds, format, setHours, setMinutes, setSeconds,
} from 'date-fns';
import { tz } from '@date-fns/tz';
import { utc } from '@date-fns/utc/utc';

class Countdown {
  formattedStartDate = '';

  formattedEndDate = '';

  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.countdownElement = element;
    const { targetDate } = this.countdownElement.dataset;
    if (!targetDate) return null;
    this.daysElement = this.countdownElement.querySelector('.countdown__days .countdown__fig');
    this.hoursElement = this.countdownElement.querySelector('.countdown__hours .countdown__fig');
    this.minutesElement = this.countdownElement.querySelector('.countdown__minutes .countdown__fig');
    this.secondsElement = this.countdownElement.querySelector('.countdown__seconds .countdown__fig');

    if (this.daysElement && this.hoursElement && this.minutesElement && this.secondsElement) {
      this.init();
    }
  }

  static formatDate(dateString, normaliseDayTimeSaving = false) {
    return format(dateString, 'yyyy-MM-dd HH:mm:ss', { in: normaliseDayTimeSaving ? utc : tz('Europe/London') });
  }

  calculateDateDifference(currDate, endDate) {
    const { hours, minutes, seconds } = intervalToDuration({
      start: currDate,
      end: endDate,
    }, {
      in: utc,
    });

    const days = differenceInDays(endDate, currDate);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  }

  initialiseCountdown(currDate, endDate) {
    const {
      days, hours, minutes, seconds,
    } = this.calculateDateDifference(currDate, endDate);

    // if the date is in the future
    const isFutureDate = [days, hours, minutes, seconds].find((duration) => duration > 0);

    if (isFutureDate) {
      this.countdownElement.classList.add('initialised');
    }
  }

  init() {
    const { targetDate } = this.countdownElement.dataset;
    const startDate = new Date();
    this.formattedStartDate = Countdown.formatDate(startDate);
    let currDate = Countdown.formatDate(startDate);
    this.formattedEndDate = Countdown.formatDate(targetDate, true);
    this.initialiseCountdown(currDate, this.formattedEndDate);
    // console.log('Start Date: ', this.formattedStartDate);
    // console.log('End date: ', this.formattedEndDate);

    if (targetDate) {
      setInterval(() => {
        // console.log('Unformatt');
        const {
          hours, minutes, seconds, days,
        } = this.calculateDateDifference(currDate, this.formattedEndDate);

        currDate = addSeconds(currDate, 1);
        this.modifyCountdownElement(this.daysElement, days);
        this.modifyCountdownElement(this.hoursElement, hours);
        this.modifyCountdownElement(this.minutesElement, minutes);
        this.modifyCountdownElement(this.secondsElement, seconds);
      }, 1000);
    }
  }

  modifyCountdownElement(element, value, defaultString = '0') {
    element.innerText = value || defaultString;
  }
}

export default Countdown;
